// extracted by mini-css-extract-plugin
export default {"page":"CalendarPage_page__2zi29","progressWrapper":"CalendarPage_progressWrapper__48qHZ"};